import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

function CreateFolderModal({ show, onHide, onCreate }) {
  const [folderName, setFolderName] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!folderName.trim()) return;

    setLoading(true);
    await onCreate(folderName.trim());
    setLoading(false);
    setFolderName('');
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Create Folder</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Group>
          <Form.Label>Folder name</Form.Label>
          <Form.Control
            type="text"
            placeholder="e.g. Bills, College, Insurance"
            value={folderName}
            onChange={(e) => setFolderName(e.target.value)}
            autoFocus
          />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleSubmit}
          disabled={loading || !folderName.trim()}
        >
          {loading ? 'Creating...' : 'Create'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default CreateFolderModal;
